// Разнасяне на отчети — заявките, добавени с редизайна (анулиране с причина,
// справката с анулираните). Заварените (preview, create, pending…) са още в
// `inventory.ts` и се местят тук при всяка задача, която ги докосва.
import { api } from "./client";
import type { ReportPosting, ReportPostingsParams } from "./inventory";

export type DocumentStatusFilter = "active" | "annulled" | "all";

// Разнесените отчети за период, по избор и анулираните (`status=all`). Стар BE
// не знае `status` и връща само активните — справката тогава просто няма
// анулирани.
export async function getPostedReports(
  params: ReportPostingsParams & { status?: DocumentStatusFilter },
): Promise<ReportPosting[]> {
  const res = await api.get<ReportPosting[]>("/inventory/report-postings", {
    params,
  });
  return res.data;
}

// Анулиране с причина. Причината е НЕЗАДЪЛЖИТЕЛНА и отива в тялото на DELETE
// (`annulReason` — `reason` вече е заето за брак и замени); стар BE я игнорира.
export async function annulReportPosting(
  id: number,
  annulReason: string | null,
): Promise<void> {
  await api.delete(`/inventory/report-postings/${id}`, {
    data: annulReason ? { annulReason } : undefined,
  });
}
